import { createContext, useContext } from "react";
import { MonitoringContextProps } from "./types";

export const MonitoringContext = createContext<MonitoringContextProps>({
  awsRum: undefined,
  updateMonitoringPrincipalId: () => {},
  sessionId: undefined,
});

export const useMonitoring = () => {
  return useContext(MonitoringContext);
};
